export enum ServerEnvironment {
    Unspecified = 0,
    Production = 1,
    Demo = 2,
    QA = 3,
    Dev = 4,
    Uat = 5,
    Staging = 6
}
